var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['fixed', _vm.isEmbedded ? 'bottom-5 end-5' : 'bottom-6 end-11']},[_c('OzContainedButton',{class:[
      // Button style
      'relative',
      'flex justify-center items-center',
      'shadow-elevation-2',
      'rounded-full',
      'p-4',

      !_vm.isMap && [
        // Tooltip style
        'before:absolute ltr:before:right-[calc(100%+0.5rem)] rtl:before:left-[calc(100%+0.5rem)]',
        'before:invisible',
        'before:shadow-elevation-2',
        'before:rounded-sm',
        'before:w-89',
        'before:px-4 before:py-2',
        'before:bg-grey-600',
        'before:cursor-default before:pointer-events-none',
        'before:text-body before:font-sans before:text-start',
        'before:text-light-text-100',
        'hover-hover:hover:before:visible',
        'hover-hover:hover:before:content-[attr(data-tooltip)]',

        // Tooltip arrow style
        'after:absolute after:top-[calc(50%-0.5rem)] after:end-full',
        'after:invisible',
        'after:border-solid after:border-8 after:border-e-0',
        'ltr:after:border-transparent ltr:after:border-l-grey-600 rtl:after:border-transparent rtl:after:border-r-grey-600',
        'after:cursor-default after:pointer-events-none',
        'hover-hover:hover:after:visible',
      ],
      // classes for stylings when the button uses skin colors
      {
        'add-post-button-skin-color': _vm.useSkinColors,
        'add-post-button-skin-dark': _vm.useSkinColors && _vm.isButtonSkinColorDark,
        'add-post-button-skin-light': _vm.useSkinColors && !_vm.isButtonSkinColorDark,
      },
    ],style:(_vm.skinColorCssVariables),attrs:{"size-preset":null,"color-scheme":_vm.useSkinColors ? _vm.OzContainedButtonColorScheme.Bare : _vm.OzContainedButtonColorScheme.Primary,"dark-mode":_vm.darkMode,"data-tooltip":!_vm.isMap && _vm.__('Double click anywhere, drag files in, paste from clipboard, or click here to post.'),"aria-label":_vm.__('Add post'),"title":_vm.__('Add post'),"data-pepin-id":_vm.isMap ? 'surface-open-location-picker-panel' : 'surface-open-post-composer',"data-pepin-trigger":"click","data-cy":"surfaceAddPostButton","data-pw":"surfaceAddPostButton"},on:{"mouseenter":function($event){return _vm.setHover(true)},"focus":function($event){return _vm.setHover(true)},"mouseleave":function($event){return _vm.setHover(false)},"blur":function($event){return _vm.setHover(false)},"click":function($event){_vm.isMap ? _vm.startPickingLocation() : _vm.startNewPost()}}},[_c('Transition',{attrs:{"name":"rotate","mode":"out-in"}},[(!_vm.isHovered)?_c('OzIcon',{key:"plus_thick",attrs:{"name":"plus_thick","size":24}}):_c('OzIcon',{key:"pencil_filled",attrs:{"name":"pencil_filled","size":24}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }